const ROUTES_OBJECT = Object.freeze({
  HOME: "/",
  CONSULTAION: "/consultation",
  REGISTRATIONOFCOOPERATION: "/webinar",
  INSTALLGUIDE:"/install-guide",
  FLASH: "/flash",
  FAVORITEFLASH: "/favoriteFlash",
  ABOUT: "/about",
  CONTACT: "/contact",
  SHOP: "/shop",
  PDFVIEW: "/pdf-view/:id",
  VIDEOVIEW: "/video-view/:id",
  LOGIN: "/login",
  MYACCOUNT: "/my-account",
  CARD: "/card",
  WISHLIST: "/wishlist",
  BLOG: "/blog",
  SINGLEBLOG: "/blog/:title",
  PRODUCT: "/product/:id",
  SEARCH: "/search/:id",
  MYLIBRARY: '/myLibrary',
  DIGIPAYPAYMENT: "/digiPayPayment",
  ERROR404: "*",
});
export { ROUTES_OBJECT };
